enum Env {
  dev = 'dev',
  staging = 'staging',
  prod = 'prod'
}

export { Env };

export const env = {
  STAGE: process.env.REACT_APP_ENV as Env,
  GRAPHQL_ENDPOINT: process.env.REACT_APP_GRAPHQL_ENDPOINT as string,
  EVENTS_ENDPOINT: process.env.REACT_APP_EVENTS_ENDPOINT as string,
  META_APP_ID: process.env.REACT_APP_META_APP_ID as string,
  FACEBOOK_LOGIN_CONFIG_ID: process.env
    .REACT_APP_FACEBOOK_LOGIN_CONFIG_ID as string,
  TWILIO_PARTNER_SOLUTION_ID: process.env
    .REACT_APP_TWILIO_PARTNER_SOLUTION_ID as string,
  MUI_LICENSE_KEY: process.env.REACT_APP_MUI_LICENSE_KEY as string,
  POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST as string,
  POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY as string,
  PENDO_API_KEY: process.env.REACT_APP_PUBLIC_PENDO_API_KEY as
    | string
    | undefined,
  COOKIE_DOMAIN: process.env.REACT_APP_COOKIE_DOMAIN as string | undefined
} as const;

const optionalKeys: Set<string> = new Set(['PENDO_API_KEY', 'COOKIE_DOMAIN']);

Object.entries(env).forEach(([key, value]) => {
  if (!value && !optionalKeys.has(key)) {
    throw new Error(
      `Missing required environment variable for ${key}.\n` +
        'Please check your .env file and ensure all required variables are set.'
    );
  }
});

if (!(env.STAGE in Env)) {
  throw new Error(
    `Invalid environment: ${env.STAGE}. Must be one of: ${Object.values(
      Env
    ).join(', ')}`
  );
}
